import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user', 'userIsPatient'])
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/resources/computed.js